<template>
  <section class="section">
    <h1 class="title is-1 has-text-centered">
      <span class="is-block">This doesn't go anywhere!</span>
      <span class="is-block">Please double check your link.</span>
    </h1>
  </section>
</template>

<script>
export default {
};
</script>
